import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Change the antenna parameters (number of microphones and spacing between them). Then plot the directivity pattern for different angles and frequencies using the sliders. You can also listen to the output of the sum and delay beamformer. The blue dot represents the direction of arrival of the the sine signal while the orange dot represents the direction of arrival of the music signal.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0427/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
